import React from 'react'
import { Button } from '@workwhile/ui'
import { useFormContext } from 'react-hook-form'
import { FiltersSchema } from './filtersSchema'
import { useShiftsContextValue } from '../../context/ShiftsProvider'

export const SearchButton = () => {
  const {
    actions: {
      setTimeRangeFilters,
      setShiftFilters,
      setCompanyFilters,
      setPagination,
    },
  } = useShiftsContextValue()

  const {
    handleSubmit,
    formState: { isValid },
  } = useFormContext<FiltersSchema>()

  const onSubmit = (data: FiltersSchema) => {
    setPagination((prev) => ({
      ...prev,
      pageIndex: 0,
    }))
    setTimeRangeFilters({
      type: data.timeRange?.type,
      startDate: data.timeRange?.dateRange?.from,
      endDate: data.timeRange?.dateRange?.to,
    })
    setShiftFilters({
      shiftIds: data.shift.ids?.map((id) => id.id) ?? [],
      listingIds: data.shift.listingIds?.map((id) => id.id) ?? [],
      locationIds: data.shift.locationIds?.map((id) => id.id) ?? [],
      marketCodes: data.shift.marketCodes?.map((code) => code.code) ?? [],
      scheduleRateMin: data.shift.scheduleRateMin ?? null,
      scheduleRateMax: data.shift.scheduleRateMax ?? null,
      fillRateMin: data.shift.fillRateMin ?? null,
      fillRateMax: data.shift.fillRateMax ?? null,
      shiftStatuses: data.shift.statuses,
      positionIds: data.shift.positionIds?.map((id) => id.id) ?? [],
      rosterRestrictions: data.shift.rosterRestrictions,
      isStandby: data.shift.isStandby ?? null,
    })
    setCompanyFilters({
      companyIds: data.company.companyIds?.map((id) => id.id) ?? [],
      companyGroupIds: data.company.companyGroupIds?.map((id) => id.id) ?? [],
      salesOwnerIds: data.company.salesOwnerIds?.map((id) => id.id) ?? [],
      accountOwnerIds: data.company.accountOwnerIds?.map((id) => id.id) ?? [],
      companyTypes: data.company.companyTypes,
    })
  }

  return (
    <Button
      block={false}
      kind="medium"
      onClick={handleSubmit(onSubmit)}
      disabled={!isValid}
    >
      Search
    </Button>
  )
}
